import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "../environments/environment.production";
import { Observable } from 'rxjs'; // <-- Importa Observable

@Injectable({
  providedIn: 'root'
})
export class ImprimirSolicitudCdniGenerico {

  private endPoint: string = `${environment.HOST_DOCUMENT}`;

  constructor(private http: HttpClient) { }

  // El método ahora devuelve un Observable que emitirá el archivo (Blob)
  imprimirSolicitudCdniGenerico(
    strNombreCompleto: string, strRfc: string, strRfcRepresentante: string, strRazonSocial: string, strCurp: string, strDomicilio: string, strMunicipio: string, strEstado: string, strGarantias: string, strNiv: string,
    strPlaca: string, strMarca: string, strEstadoVehiculo: string, strModelo: string, strRefrendo: string, strTipoServicio: string, strNumeroMotor: string, strRepuve: string,
    strTipoPersona: string
  ): Observable<Blob> { // <-- CAMBIO: Se define el tipo de retorno

    const params = new HttpParams()
      .set('strNombreCompleto', strNombreCompleto)
      .set('strRfc', strRfc)
      .set('strRfcRepresentante',strRfcRepresentante)
      .set('strRazonSocial', strRazonSocial)
      .set('strCurp', strCurp)
      .set('strDomicilio', strDomicilio)
      .set('strMunicipio', strMunicipio)
      .set('strEstado', strEstado)
      .set('strGarantias', strGarantias)
      .set('strNiv', strNiv)
      .set('strPlaca', strPlaca)
      .set('strMarca', strMarca)
      .set('strEstadoVehiculo', strEstadoVehiculo)
      .set('strModelo', strModelo)
      .set('strRefrendo', strRefrendo)
      .set('strTipoServicio', strTipoServicio)
      .set('strNumeroMotor', strNumeroMotor)
      .set('strRepuve', strRepuve)
      .set('strTipoPersona', strTipoPersona);



   //const url = `${this.endPoint}/generar-solicitud-pdf`;
    //const url = `http://10.20.0.11:8080/formatos/imprimirSolicitudCdni`;


    const url = `${this.endPoint}/formatos/imprimirSolicitudCdni`;
   
    // <-- CAMBIO: Se realiza la llamada GET y se retorna el Observable
    return this.http.get(url, {
      params: params,
      responseType: 'blob'
    });
  }
}